import Vue from 'vue'
import Vuex from 'vuex'
import {
  refresh
} from './api/refresh'

import {
  log
} from './api/log'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: '',
    dans: [{
        name: '青铜',
        childDans: [3, 2, 1, 0, 0],
        values: ['青铜3', '青铜2', '青铜1', '', ''],
        starCount: 3,
        level: 0
      },
      {
        name: '白银',
        childDans: [3, 2, 1, 0, 0],
        values: ['白银3', '白银2', '白银1', '', ''],
        starCount: 4,
        level: 1
      },
      {
        name: '黄金',
        childDans: [4, 3, 2, 1, 0],
        values: ['黄金4', '黄金3', '黄金2', '黄金1', ''],
        starCount: 4,
        level: 2
      },
      {
        name: '铂金',
        childDans: [4, 3, 2, 1, 0],
        values: ['铂金4', '铂金3', '铂金2', '铂金1', ''],
        starCount: 4,
        level: 3
      },
      {
        name: '钻石',
        childDans: [5, 4, 3, 2, 1],
        values: ['钻石5', '钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 5,
        level: 4
      },
      {
        name: '星耀',
        childDans: [5, 4, 3, 2, 1],
        values: ['星耀5', '星耀4', '星耀3', '星耀2', '星耀1'],
        starCount: 5,
        level: 5
      },
      {
        name: '王者',
        childDans: ['A', 'B', 0, 0, 0],
        values: ['王者', '王者', '', '', ''],
        starCount: 5,
        level: 6
      }
    ],
    lolDans: [{
        name: '黑铁',
        childDans: [4, 3, 2, 1],
        values: ['黑铁4', '黑铁3', '黑铁2', '黑铁1'],
        starCount: 4,
        level: 0
      },
      {
        name: '青铜',
        childDans: [4, 3, 2, 1],
        values: ['青铜4', '青铜3', '青铜2', '青铜1'],
        starCount: 4,
        level: 1
      },
      {
        name: '白银',
        childDans: [4, 3, 2, 1],
        values: ['白银4', '白银3', '白银2', '白银1'],
        starCount: 4,
        level: 2
      },
      {
        name: '黄金',
        childDans: [4, 3, 2, 1],
        values: ['黄金4', '黄金3', '黄金2', '黄金1'],
        starCount: 4,
        level: 3
      },
      {
        name: '铂金',
        childDans: [4, 3, 2, 1],
        values: ['铂金4', '铂金3', '铂金2', '铂金1'],
        starCount: 4,
        level: 4
      },
      {
        name: '翡翠',
        childDans: [4, 3, 2, 1],
        values: ['翡翠4', '翡翠3', '翡翠2', '翡翠1' ],
        starCount: 4,
        level: 6
      },
      {
        name: '钻石',
        childDans: [4, 3, 2, 1],
        values: ['钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 4,
        level: 7
      },
      {
        name: '大师',
        childDans: ['A', 'B', 0, 0, 0],
        values: ['大师', '大师', '', '', ''],
        starCount: 5,
        level: 8
      },
    ],
    lolPositionDans: [{
        name: '新号定位赛',
        level: 1
      },
      {
        name: '青铜定位赛',
        level: 2
      },
      {
        name: '白银定位赛',
        level: 3
      },
      {
        name: '黄金定位赛',
        level: 4
      },
      {
        name: '铂金定位赛',
        level: 5
      },
      {
        name: '翡翠定位赛',
        level: 6
      },
      {
        name: '钻石定位赛',
        level: 7
      },
      {
        name: '大师定位赛',
        level: 8
      },
      {
        name: '宗师定位赛',
        level: 9
      },
      {
        name: '王者分段',
        level: 9
      },
    ],
    gpDans: [{
        id: 1,
        name: '青铜',
        childDans: [5, 4, 3, 2, 1],
        values: ['青铜5', '青铜4', '青铜3', '青铜2', '青铜1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 2,
        name: '白银',
        childDans: [5, 4, 3, 2, 1],
        values: ['白银5', '白银4', '白银3', '白银2', '白银1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 3,
        name: '黄金',
        childDans: [5, 4, 3, 2, 1],
        values: ['黄金5', '黄金4', '黄金3', '黄金2', '黄金1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 4,
        name: '铂金',
        childDans: [5, 4, 3, 2, 1],
        values: ['铂金5', '铂金4', '铂金3', '铂金2', '铂金1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 5,
        name: '星钻',
        childDans: [5, 4, 3, 2, 1],
        values: ['星钻5', '星钻4', '星钻3', '星钻2', '星钻1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 6,
        name: '皇冠',
        childDans: [5, 4, 3, 2, 1],
        values: ['皇冠5', '皇冠4', '皇冠3', '皇冠2', '皇冠1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 7,
        name: '王牌',
        childDans: ['A', 'B', 0, 0, 0],
        values: ['王牌', '王牌', '', '', ''],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
    ],
    tyDans: [{
        name: '1段',
        level: 1
      }, {
        name: '2段',
        level: 2
      },
      {
        name: '3段',
        level: 3
      },
      {
        name: '4段',
        level: 4
      },
      {
        name: '5段',
        level: 5
      },
      {
        name: '6段',
        level: 6
      },
      {
        name: '7段',
        level: 7
      },
      {
        name: '8段',
        level: 8
      },
      {
        name: '9段',
        level: 9
      },
      {
        name: '试剑',
        level: 10
      },
      {
        name: '利剑',
        level: 11
      },
      {
        name: '快剑',
        level: 12
      },
      {
        name: '飞剑',
        level: 13
      },
      {
        name: '神剑',
        level: 14
      },
      {
        name: '意剑',
        level: 15
      },
      {
        name: '心剑',
        level: 16
      },
      {
        name: '白虹',
        level: 17
      },
      {
        name: '秋水',
        level: 1
      },
      {
        name: '吹雪',
        level: 18
      },
      {
        name: '登峰',
        level: 19
      },
      {
        name: '造极',
        level: 20
      },
      {
        name: '化境',
        level: 21
      },
      {
        name: '武痴',
        level: 22
      },
      {
        name: '武尊',
        level: 23
      },
      {
        name: '武圣',
        level: 24
      },
      {
        name: '求败',
        level: 25
      },
    ],
    codmDans: [{
        id: 1,
        name: '青铜',
        childDans: [5, 4, 3, 2, 1],
        values: ['青铜5', '青铜4', '青铜3', '青铜2', '青铜1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      }, {
        id: 2,
        name: '白银',
        childDans: [5, 4, 3, 2, 1],
        values: ['白银5', '白银4', '白银3', '白银2', '白银1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 3,
        name: '黄金',
        childDans: [5, 4, 3, 2, 1],
        values: ['黄金5', '黄金4', '黄金3', '黄金2', '黄金1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 4,
        name: '铂金',
        childDans: [5, 4, 3, 2, 1],
        values: ['铂金5', '铂金4', '铂金3', '铂金2', '铂金1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 5,
        name: '钻石',
        childDans: [5, 4, 3, 2, 1],
        values: ['钻石5', '钻石4', '钻石3', '钻石2', '钻石1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 6,
        name: '大师',
        childDans: [5, 4, 3, 2, 1],
        values: ['大师5', '大师4', '大师3', '大师2', '大师1'],
        level: [1, 2, 3, 4, 5],
        starCount: 5
      },
      {
        id: 7,
        name: '战神',
        childDans: [1],
        values: ['战神8001分'],
        level: [1],
        starCount: 1
      },

    ],
    mlolDans: [{
        id: 1,
        name: '黑铁',
        childDans: [4, 3, 2, 1],
        values: ['黑铁4', '黑铁3', '黑铁2', '黑铁1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 2,
        name: '黄铜',
        childDans: [4, 3, 2, 1],
        values: ['黄铜4', '黄铜3', '黄铜2', '黄铜1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 3,
        name: '白银',
        childDans: [4, 3, 2, 1],
        values: ['白银4', '白银3', '白银2', '白银1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 4,
        name: '金牌',
        childDans: [4, 3, 2, 1],
        values: ['金牌4', '金牌3', '金牌2', '金牌1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 5,
        name: '铂金',
        childDans: [4, 3, 2, 1],
        values: ['铂金4', '铂金3', '铂金2', '铂金1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 6,
        name: '翡翠',
        childDans: [4, 3, 2, 1],
        values: ['翡翠4', '翡翠3', '翡翠2', '翡翠1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 7,
        name: '钻石',
        childDans: [4, 3, 2, 1],
        values: ['钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 6,
        level: [1, 2, 3, 4, 5],
        isVictoryPoint: false
      },
      {
        id: 8,
        name: '大师',
        childDans: ['A', 'B', 0, 0],
        values: ['大师', '大师', '', ''],
        starCount: 0,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
    ],
    jccDans: [{
        id: 1,
        name: '黑铁',
        childDans: [4, 3, 2, 1],
        values: ['黑铁4', '黑铁3', '黑铁2', '黑铁1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 2,
        name: '黄铜',
        childDans: [4, 3, 2, 1],
        values: ['黄铜4', '黄铜3', '黄铜2', '黄铜1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 3,
        name: '白银',
        childDans: [4, 3, 2, 1],
        values: ['白银4', '白银3', '白银2', '白银1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 4,
        name: '黄金',
        childDans: [4, 3, 2, 1],
        values: ['黄金4', '黄金3', '黄金2', '黄金1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 5,
        name: '铂金',
        childDans: [4, 3, 2, 1],
        values: ['铂金4', '铂金3', '铂金2', '铂金1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 6,
        name: '钻石',
        childDans: [4, 3, 2, 1],
        values: ['钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 7,
        name: '大师',
        childDans: ['A', 'B', 0, 0],
        values: ['大师', '大师', '', ''],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },

    ],
    mGFlolDans: [{
        id: 1,
        name: '黑铁',
        childDans: [4, 3, 2, 1],
        values: ['黑铁4', '黑铁3', '黑铁2', '黑铁1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 2,
        name: '黄铜',
        childDans: [4, 3, 2, 1],
        values: ['黄铜4', '黄铜3', '黄铜2', '黄铜1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 3,
        name: '白银',
        childDans: [4, 3, 2, 1],
        values: ['白银4', '白银3', '白银2', '白银1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 4,
        name: '黄金',
        childDans: [4, 3, 2, 1],
        values: ['黄金4', '黄金3', '黄金2', '黄金1'],
        starCount: 4,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 5,
        name: '铂金',
        childDans: [4, 3, 2, 1],
        values: ['铂金4', '铂金3', '铂金2', '铂金1'],
        starCount: 4,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 6,
        name: '翡翠',
        childDans: [4, 3, 2, 1],
        values: ['翡翠4', '翡翠3', '翡翠2', '翡翠1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 7,
        name: '钻石',
        childDans: [4, 3, 2, 1],
        values: ['钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 6,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 8,
        name: '大师',
        childDans: ['A', 'B', 0, 0],
        values: ['大师', '大师', '', ''],
        starCount: 1,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },

    ],
    //英雄联盟手游,峡谷之巅
    mGFXGlolDans: [{
        id: 1,
        name: '开拓者',
        childDans: [4, 3, 2, 1],
        values: ['开拓者4', '开拓者3', '开拓者2', '开拓者1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 2,
        name: '挑战者',
        childDans: [4, 3, 2, 1],
        values: ['挑战者4', '挑战者3', '挑战者2', '挑战者1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 3,
        name: '超越者',
        childDans: [4, 3, 2, 1],
        values: ['超越者4', '超越者3', '超越者2', '超越者1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 4,
        name: '征服者',
        childDans: [4, 3, 2, 1],
        values: ['征服者4', '征服者3', '征服者2', '征服者1'],
        starCount: 4,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 5,
        name: '不灭者',
        childDans: [4, 3, 2, 1],
        values: ['不灭者4', '不灭者3', '不灭者2', '不灭者1'],
        starCount: 4,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 8,
        name: '传说',
        childDans: ['A', 'B', 0, 0],
        values: ['传说', '传说', '', ''],
        starCount: 1,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },

    ],
    wyRaceDans: [{
        id: 1,
        name: '新秀',
        childDans: [3, 2, 1],
        values: ['新秀出道3', '新秀出道2', '新秀出道1'],
        starCount: 3,
        level: [1, 2, 3],
        isVictoryPoint: false
      },
      {
        id: 2,
        name: '小有',
        childDans: [3, 2, 1],
        values: ['小有名气3', '小有名气2', '小有名气1'],
        starCount: 3,
        level: [1, 2, 3],
        isVictoryPoint: false
      },
      {
        id: 3,
        name: '职业',
        childDans: [3, 2, 1],
        values: ['职业车手3', '职业车手2', '职业车手1'],
        starCount: 3,
        level: [1, 2, 3],
        isVictoryPoint: false
      },
      {
        id: 4,
        name: '精英',
        childDans: [4, 3, 2, 1],
        values: ['赛道精英4', '赛道精英3', '赛道精英2', '赛道精英1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 5,
        name: '专家',
        childDans: [5, 4, 3, 2, 1],
        values: ['竞速专家5', '竞速专家4', '竞速专家3', '竞速专家2', '竞速专家1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 6,
        name: '大师',
        childDans: [5, 4, 3, 2, 1],
        values: ['漂移大师5', '漂移大师4', '漂移大师3', '漂移大师2', '漂移大师1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 7,
        name: '王者',
        childDans: [5, 4, 3, 2, 1],
        values: ['王者车手5', '王者车手4', '王者车手3', '王者车手2', '王者车手1'],
        starCount: 3,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 8,
        name: '传奇',
        childDans: ['A', 'B'],
        values: ['竞速传奇', '竞速传奇'],
        starCount: 2,
        level: [1, 2],
        isVictoryPoint: false
      },
    ],
    qqCoaster: [{
        name: '青铜',
        childDans: [5, 4, 3, 2, 1],
        values: ['青铜5', '青铜4', '青铜3', '青铜2', '青铜1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      },
      {
        name: '白银',
        childDans: [5, 4, 3, 2, 1],
        values: ['白银5', '白银4', '白银3', '白银2', '白银1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      },
      {
        name: '黄金',
        childDans: [5, 4, 3, 2, 1],
        values: ['黄金5', '黄金4', '黄金3', '黄金2', '黄金1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      },
      {
        name: '铂金',
        childDans: [5, 4, 3, 2, 1],
        values: ['铂金5', '铂金4', '铂金3', '铂金2', '铂金1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      },
      {
        name: '钻石',
        childDans: [5, 4, 3, 2, 1],
        values: ['钻石5', '钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      },
      {
        name: '星耀',
        childDans: [5, 4, 3, 2, 1],
        values: ['星耀5', '星耀4', '星耀3', '星耀2', '星耀1'],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      },
      {
        name: '车神',
        childDans: ['A', 'B', 0, 0, 0],
        values: ['车神', '车神', '', '', ''],
        starCount: 5,
        level: [1, 2, 3, 4, 5],
      }
    ],
    yundingDans: [{
        id: 1,
        name: '黑铁',
        childDans: [4, 3, 2, 1],
        values: ['黑铁4', '黑铁3', '黑铁2', '黑铁1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 2,
        name: '黄铜',
        childDans: [4, 3, 2, 1],
        values: ['黄铜4', '黄铜3', '黄铜2', '黄铜1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 3,
        name: '白银',
        childDans: [4, 3, 2, 1],
        values: ['白银4', '白银3', '白银2', '白银1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 4,
        name: '黄金',
        childDans: [4, 3, 2, 1],
        values: ['黄金4', '黄金3', '黄金2', '黄金1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 5,
        name: '铂金',
        childDans: [4, 3, 2, 1],
        values: ['铂金4', '铂金3', '铂金2', '铂金1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 6,
        name: '钻石',
        childDans: [4, 3, 2, 1],
        values: ['钻石4', '钻石3', '钻石2', '钻石1'],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },
      {
        id: 7,
        name: '大师',
        childDans: ['A', 'B', 0, 0],
        values: ['大师', '大师', '', ''],
        starCount: 5,
        level: [1, 2, 3, 4],
        isVictoryPoint: false
      },

    ],

    msgUnreadSize: 0,
    // 当前用户
    user: {
      accountNo: '',
      name: '',
      img: 'https://xmf-pigeon.oss-cn-hangzhou.aliyuncs.com/public/%E5%AE%A2%E6%9C%8D%E5%A4%B4%E5%83%8F.jpg'
    },
    // 会话列表
    sessions: [],
    session: {},
    // 当前选中的会话
    currentSessionId: 1,
    // 过滤出只包含这个key的会话
    filterKey: '',
    socket: null,
    msgRes: {},
    socketStatus: -1,
    connectionNum: 0,
    socketHeartbeat: null,
    webDB: null,
    //播放提示音
    playing: null,
    //是否播放提示音
    isPlaying: true,
    //是否刷新
    isRefresh: false,
    //版本号
    version: 0,
    //平台消息提醒
    platformMsgWarn: true,
    //客服消息提醒
    serviceMsgWarn: true,
    //默认menu
    defaultMenu: [{
        id: 1,
        name: '王者荣耀',
        index: '2-10',
        path: '/main/price/king',
        isCheck: true,
        level: 100,
        icon:''
      },
      {
        id: 2,
        name: '英雄联盟',
        index: '2-200',
        path: '/main/price/lol',
        isCheck: true,
        level: 220,
        icon:''
      },
      {
        id: 3,
        name: '使命召唤',
        index: '2-300',
        path: '/main/price/codm',
        isCheck: true,
        level: 270,
        icon:''
      },
      {
        id: 4,
        name: '和平精英',
        index: '2-400',
        path: '/main/price/gp',
        isCheck: true,
        level: 210,
        icon:''
      },
      {
        id: 5,
        name: '荒野乱斗',
        index: '2-500',
        path: '/main/price/bs',
        isCheck: true,
        level: 302,
        icon:''
      },
      {
        id: 6,
        name: '天涯明月刀',
        index: '2-600',
        path: '/main/price/ty',
        isCheck: true,
        level: 303,
        icon:''
      },
      {
        id: 7,
        name: '原神',
        index: '2-700',
        path: '/main/price/gi',
        isCheck: true,
        level: 110,
        icon:''
      },
      {
        id: 8,
        name: 'lol手游(外服)',
        index: '2-201',
        path: '/main/price/mlol',
        isCheck: true,
        level: 240,
        icon:''
      },
      {
        id: 9,
        name: '金铲铲',
        index: '2-204',
        path: '/main/price/jcc',
        isCheck: true,
        level: 250,
        icon:''
      },
      {
        id: 10,
        name: 'lol手游(国服)',
        index: '2-203',
        path: '/main/price/mGFLOL',
        isCheck: true,
        level: 230,
        icon:''
      },
      {
        id: 11,
        name: '王牌竞速',
        index: '2-700',
        path: '/main/price/WyRace',
        isCheck: true,
        level: 301,
        icon:''
      },
      {
        id: 12,
        name: 'QQ飞车(手游)',
        index: '2-800',
        path: '/main/price/QQCoaster',
        isCheck: true,
        level: 280,
        icon:''
      },
      {
        id: 13,
        name: '云顶之弈',
        index: '2-205',
        path: '/main/price/yunding',
        isCheck: true,
        level: 260,
        icon:''
      },
      // {
      //   id: 14,
      //   name: '崩坏-星穹铁道',
      //   index: '2-900',
      //   path: '/main/price/bh',
      //   isCheck: true,
      //   level: 111,
      // },

    ],
    //menu 版本号,如果不同则对比数据.
    menuVersion: '3.0',
    //快捷键
    keys: [{
        id: 1,
        code: 'price',
        name: '生成报价+复制报价',
        keyName: '空格',
        keyCode: 'space'
      },
      {
        id: 2,
        code: 'discounts',
        name: '整单优惠',
        keyName: '',
        keyCode: ' '
      },
      {
        id: 3,
        code: 'copy',
        name: '复制报价',
        keyName: '回车',
        keyCode: 'enter'
      },
      {
        id: 4,
        code: 'reset',
        name: '重置查询',
        keyName: '`',
        keyCode: '`'
      }
    ],
    noticeValue: 0
  },
  mutations: {
    SET_USER(state, value) {
      state.user = value
    },
    SET_SESSIONS(state, value) {
      state.sessions.push(value)
    },
    SET_SESSION(state, value) {
      state.session = value
    },
    CLEAR_SESSIONS(state) {
      state.sessions = []
    },
    //重新排序sessions
    SORT_SESSIONS(state) {
      let list = state.sessions
      state.sessions = list.sort((a, b) => b.lastDate > a.lastDate ? 1 : -1)
    },
    // 发送消息
    SEND_MESSAGE({
      sessions,
      currentSessionId
    }, content) {
      let session = sessions.find(item => item.id === currentSessionId)
      session.messages.push({
        content: content,
        date: new Date(),
        self: true
      })
    },
    // 选择会话
    SELECT_SESSION(state, id) {
      state.currentSessionId = id
      let index = state.sessions.findIndex(item => item.id === id)
      if (index != null && index > -1) {
        state.sessions[index].msgNum = 0
      }

      state.webDB.getItem(id).then(function (value) {
        // 当离线仓库中的值被载入时，此处代码运行
        state.session = value
      }).catch(function (err) {
        // 当出错时，此处代码运行
        console.log(err)
      })

    },
    // 搜索
    SET_FILTER_KEY(state, value) {
      state.filterKey = value
    },
    GET_MSG(state, result) {
      let index = state.sessions.findIndex(item => item.id == result.list.id)

      let value = result.msgRes
      let messages = {
        id: value.id,
        msgNum: index == -1 ? 0 : value.msgNum,
        user: value.user,
        lastDate: value.lastDate,
        platformId: value.platformId,
        SenderSource: value.SenderSource
      }
      if (index > -1) {
        let index = state.sessions.findIndex(item => item.id === result.list.id)
        state.sessions[index].lastDate = value.lastDate
        state.sessions.unshift(state.sessions.splice(index, 1)[0])

      } else {
        state.sessions.unshift(result.list)
      }
      //sendersource 1 平台系统 2 平台客服 3 平台商家 4 平台打手
      console.log(messages)
      switch (messages.SenderSource) {
        case 1:
          if (state.isPlaying == true && state.platformMsgWarn == true) {
            //提示音
            state.playing.play()
            if (index > -1) {
              //小标识提示.
              state.sessions[index].msgNum += 1
            }
          }
          break
        case 2:
          if (state.isPlaying == true && state.platformMsgWarn == true) {
            state.playing.play()
            if (index > -1) {
              state.sessions[index].msgNum += 1
            }
          }
          break
        case 3:
          break
        case 4:
          if (state.isPlaying) {
            state.playing.play()
          }
          if (index > -1) {
            state.sessions[index].msgNum += 1
          }
          break
      }

      store.commit('SELECT_SESSION', state.currentSessionId)

    },

    //连接
    SOCKET_CONNECTION(state) {
      // let url = localStorage.getItem('wsUrl')
      // let token = localStorage.getItem('token')
      // //关闭心跳包
      // store.commit('CLOSE_HEARTBEAT')
      // if (state.socket != null && state.socket.readyState == 1) {
      //   log('当前连接已存在....')
      //   state.socket.close()
      //   return
      // }
      // if (url == null || token == null || state.connectionNum > 100) {
      //   log('token为null或连接过多')
      //   return
      // }
      //
      // state.socket = new WebSocket(url + token)
      // let ws = state.socket
      // //状态
      // state.socketStatus = state.socket.readyState
      //
      // ws.onopen = function () {
      //   state.socketStatus = state.socket.readyState
      //   //连接成功
      //   log('连接成功')
      //   //启动心跳包
      //   store.commit('SOCKET_HEARTBEAT')
      // }
      //
      // ws.onclose = function (ev) {
      //   store.commit('SOCKET_ONCLOSE', ev)
      // }
      //
      // ws.onerror = function (event) {
      //   store.commit('SOCKET_ERROR', event)
      // }
      //
      // ws.onmessage = function (e) {
      //   console.log('监听接收')
      //   store.commit('SOCKET_ONMESSAGE', e)
      // }
    },
    //重连SOCket
    RECONNECTION_SOCKET(state) {
      // //关闭心跳包
      // store.commit('CLOSE_HEARTBEAT')
      //
      // window.setTimeout(function () {
      //   log('连接报错,尝试重连中....')
      //   store.dispatch('socketConnection')
      // }, 20000)

    },
    //关闭心跳包
    CLOSE_HEARTBEAT(state) {
      // window.clearInterval(state.socketHeartbeat)
    },
    //发送消息
    SOCKET_SEND(state, content) {
      state.socketStatus = state.socket.readyState
      log('发送消息中...' + state.socketStatus)
      if (state.socket.readyState == 1) {
        state.socket.send(content)
      } else {
        store.dispatch('socketConnection')
      }
    },
    //清空session
    REMOVE_SESSION(state, value) {

    },
    //接收消息
    SOCKET_ONMESSAGE(state, e) {

      console.log(e)
      if (e == undefined || e == null) {
        return
      }

      let msgRes = JSON.parse(e.data)
      let day = new Date()
      let day1 = day.setTime(day.valueOf() - (24 * 60 * 60 * 1000))

      log('接收消息')

      state.webDB.getItem(msgRes.PlatformOrderNo).then(function (value) {
        // 当离线仓库中的值被载入时，此处代码运行
        let list = value
        if (list == null) {
          list = {
            msgNum: 0,
            id: 0,
            platformOrderNo: '',
            lastDate: '',
            user: {
              name: '',
              img: 'https://xmf-pigeon.oss-cn-hangzhou.aliyuncs.com/public/%E5%AE%A2%E6%9C%8D%E5%A4%B4%E5%83%8F.jpg'
            },
            messages: []
          }
        }

        switch (msgRes.SenderSource) {
          case 1:
            if (state.platformMsgWarn == true) {
              list.msgNum += 1
            }
            break
          case 2:
            if (state.platformMsgWarn == true) {
              list.msgNum += 1
            }
            break
          case 3:
            if (state.serviceMsgWarn == true) {
              list.msgNum += 1
            }
            break
          case 4:
            list.msgNum += 1
            break
        }

        if (msgRes.VersionNo != state.version) {
          localStorage.setItem('version', msgRes.VersionNo)
          store.commit('SET_VERSION', msgRes.VersionNo)
          refresh()
        }
        list.platformId = msgRes.PlatformId
        list.id = msgRes.PlatformOrderNo
        list.platformOrderNo = msgRes.PlatformOrderNo
        list.senderId = msgRes.SenderId
        list.user.name = msgRes.RoleName

        list.lastDate = day1.valueOf()
        list.messages.push(msgRes)
        state.webDB.setItem(msgRes.PlatformOrderNo, list).then(function (value) {
          // 当值被存储后，将值赋值到vuex
          store.commit('GET_MSG', {
            msgRes,
            list
          })
        }).catch(function (err) {
          // 当出错时，此处代码运行
          console.log(err)
        })
      }).catch(e => {
        console.log(e)
      })
    },
    //socket 错误回调. 错误后调用 关闭方法
    SOCKET_ERROR(state, e) {
      state.socketStatus = state.socket.readyState
      //连接报错
      state.connectionNum += 1
      if (state.socket != null) {
        //如果存在连接.先调用关闭.
        state.socket.close()
      }
      console.log('错误日志:', e)
    },
    //关闭连接
    SOCKET_CLOSE(state) {
      state.connectionNum = 0
      if (state.socket != null) {
        //如果存在连接.先掉用关闭.
        state.socket.close()
      }
      //关闭心跳包
      window.clearInterval(state.socketHeartbeat)
    },
    //关闭后回调
    SOCKET_ONCLOSE(state, e) {
      state.socketStatus = state.socket.readyState
      console.log('socket 已关闭')
      state.connectionNum += 1
      //关闭后 调用重连方法
      store.commit('RECONNECTION_SOCKET')
    },
    //心跳包
    SOCKET_HEARTBEAT(state) {
      state.socketHeartbeat = setInterval(function () {
        log('心跳包~~~')
        store.dispatch('socketSend', '#sys.heart-beat#')
      }, 20000)
    },
    //webDB
    WEB_DB(state, value) {
      state.webDB = value
    },
    //设置pay
    SET_PLAYING(state, value) {
      state.playing = value
    },
    SET_IS_PLAYING(state, value) {
      state.isPlaying = value
      console.log(state.isPlaying, typeof (state.isPlaying))
    },
    //设置版本号
    SET_VERSION(state, value) {
      state.version = value
    },
    SET_PLATFORM_MSG_WARN(state, value) {
      state.platformMsgWarn = value
      console.log(state.platformMsgWarn)
    },
    SET_SERVICE_MSG_WARN(state, value) {
      state.serviceMsgWarn = value
    },
    SET_NOTICEVALUE(state, value) {
      state.noticeValue = value
    }
  },
  getters: {
    user: ({
      user
    }) => user,
    filterKey: ({
      filterKey
    }) => filterKey,
    sessions: ({
      sessions,
      filterKey
    }) => {
      let result = sessions.filter(session => session.user.name.includes(filterKey))
      return result
    },
    // 当前会话index
    currentId: ({
      currentSessionId
    }) => currentSessionId,
    session: ({
      session
    }) => session,
    socket: ({
      socket
    }) => socket,
    msgRes: ({
      msgRes
    }) => msgRes,
    webDB: ({
      webDB
    }) => webDB,
    paying: ({
      paying
    }) => paying,
    socketStatus: ({
      socketStatus
    }) => socketStatus,
    platformMsgWarn: ({
      platformMsgWarn
    }) => platformMsgWarn,
    serviceMsgWarn: ({
      serviceMsgWarn
    }) => serviceMsgWarn,
    defaultMenu: ({
      defaultMenu
    }) => defaultMenu,
    keys: ({
      keys
    }) => keys,
    isNotice: ({
      isNotice
    }) => isNotice
  },
  actions: {
    setUser: ({
      commit
    }, value) => commit('SET_USER', value),
    setSessions: ({
      commit
    }, value) => commit('SET_SESSIONS', value),
    sendMessage: ({
      commit
    }, content) => commit('SEND_MESSAGE', content),
    selectSession: ({
      commit
    }, id) => commit('SELECT_SESSION', id),
    search: ({
      commit
    }, value) => commit('SET_FILTER_KEY', value),
    socketConnection: ({
      commit
    }) => {
      commit('SOCKET_CONNECTION')
    },
    socketSubscribe: ({
      commit
    }) => commit('SOCKET_SUBSCRIBE'),
    socketSend: ({
      commit
    }, content) => {
      commit('SOCKET_SEND', content)
    },
    getMsg: ({
      commit
    }, result) => {
      commit('GET_MSG', result)
    },
    socketClose: ({
      commit
    }) => {
      commit('SOCKET_CLOSE')
    },
    setnoticeValue: ({
      commit
    }, value) => {
      commit('SET_NOTICEVALUE', value)
    }
  }
})

store.watch(
  (state) => state.sessions,
  (val) => {
    //console.log('CHANGE: ', state.currentSessionId)
    //localStorage.setItem('vue-chat-session', JSON.stringify(val));
  }, {
    deep: true
  }
)
export default store
